var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_947_26912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C4.85775 16.5 1.5 13.1423 1.5 9C1.5 4.85775 4.85775 1.5 9 1.5C13.1423 1.5 16.5 4.85775 16.5 9C16.5 13.1423 13.1423 16.5 9 16.5ZM9 15C10.5913 15 12.1174 14.3679 13.2426 13.2426C14.3679 12.1174 15 10.5913 15 9C15 7.4087 14.3679 5.88258 13.2426 4.75736C12.1174 3.63214 10.5913 3 9 3C7.4087 3 5.88258 3.63214 4.75736 4.75736C3.63214 5.88258 3 7.4087 3 9C3 10.5913 3.63214 12.1174 4.75736 13.2426C5.88258 14.3679 7.4087 15 9 15ZM8.25 11.25H9.75V12.75H8.25V11.25ZM9.75 10.0162V10.5H8.25V9.375C8.25 9.17609 8.32902 8.98532 8.46967 8.84467C8.61032 8.70402 8.80109 8.625 9 8.625C9.21306 8.62499 9.42173 8.56447 9.60174 8.4505C9.78175 8.33652 9.9257 8.17377 10.0168 7.98119C10.108 7.7886 10.1425 7.5741 10.1165 7.36263C10.0905 7.15117 10.005 6.95144 9.86987 6.78668C9.73478 6.62193 9.55568 6.49892 9.35342 6.43198C9.15115 6.36503 8.93403 6.3569 8.72732 6.40853C8.52061 6.46016 8.33281 6.56942 8.18577 6.72361C8.03874 6.8778 7.93851 7.07057 7.89675 7.2795L6.42525 6.98475C6.51647 6.52881 6.72713 6.10528 7.03569 5.75744C7.34425 5.4096 7.73964 5.14994 8.18144 5.00499C8.62325 4.86004 9.09561 4.83501 9.55026 4.93246C10.0049 5.02991 10.4255 5.24634 10.7691 5.55962C11.1127 5.8729 11.3669 6.2718 11.5058 6.71555C11.6447 7.15929 11.6633 7.63196 11.5596 8.08523C11.456 8.5385 11.2338 8.95612 10.9159 9.2954C10.5979 9.63467 10.1956 9.88343 9.75 10.0162Z",
    fill: "#1865C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_947_26912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionLine);
export default __webpack_public_path__ + "static/media/question-line.23891f5ea4c5d25ead08dc1361263ba2.svg";
export { ForwardRef as ReactComponent };